/**
 * lucide-react v0.233.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const BookKey = createLucideIcon("BookKey", [
  ["path", { d: "M20,2l-4.5,4.5", key: "bnnza" }],
  ["path", { d: "M19,3l1,1", key: "pg79hc" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }],
  ["path", { d: "M4,19.5C4,18.1,5.1,17,6.5,17H20", key: "dolp24" }],
  [
    "path",
    {
      d: "M20,8v14H6.5C5.1,22,4,20.9,4,19.5v-15C4,3.1,5.1,2,6.5,2H14",
      key: "1w7fhz"
    }
  ]
]);

export { BookKey as default };
//# sourceMappingURL=book-key.js.map
